import { Box, Typography, Grid } from '@mui/material'
import { useFormik } from 'formik'
import { updateProfile } from 'services/userServices'
import { ColStack } from 'components/atoms/container/InCardStack'
import { useEffect, useState } from 'react'
import { getConstant } from 'services/constantServices'
import { CONSTANTS_OPTIONS } from 'services/constants'
import { getLocalUser } from 'utils/localStorage'
import StepOneProfilePhoto from './StepOneProfilePhoto'
import NavigateButtons from 'components/molecules/onboarding/NavigateButtons'
import { getOnboardingSteps } from 'components/molecules/onboarding/PathOnboardingMolecules'
import OverlayLoading from 'components/atoms/OverlayLoading'
import RequestRetryAlert from 'components/atoms/RequestRetryAlert'
import { ToggleOptions } from 'components/molecules/onboarding/PathOnboardingMolecules'

const QuestionOptionsTemplate = ({ question, options }) => {
  return (
    <ColStack spacing={16}>
      <Typography variant='h2'>{question}</Typography>
      <Box>{options}</Box>
    </ColStack>
  )
}
const StepOne = ({
  subStep,
  onNextCallback = () => {},
  onBackCallback = () => {}
}) => {
  const userInfo = getLocalUser()
  const [requestError, setRequestError] = useState(undefined)
  const [answers, setAnswers] = useState(userInfo.onboardingAnswers || {})
  const [profileImage, setProfileImage] = useState(userInfo.profile_image)
  const [questions, setQuestions] = useState([])
  const [showNext, setShowNext] = useState(false)
  const [loading, setLoading] = useState(false)
  const onboardingSteps = getOnboardingSteps()

  useEffect(() => {
    const fetchData = async () => {
      const questionRes = await getConstant(
        CONSTANTS_OPTIONS.ONBOARDING_QUESTIONNAIRE
      )
      if (!questionRes) {
        setRequestError(true)
      } else {
        setRequestError(false)
        setQuestions(
          questionRes.filter(q => q.questionId === 0 || q.questionId === 1)
        )
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const formik = useFormik({
    initialValues: {
      profileImage: null,
      questionnaireAnswers: userInfo.onboardingAnswers || {}
    },
    onSubmit: async values => {
      setRequestError(false)
      setLoading(true)
      const data = new FormData()
      if (values.profileImage) {
        data.append('profile_image', values.profileImage)
      }
      data.append(
        'onboardingAnswers',
        JSON.stringify(values.questionnaireAnswers)
      )
      const res = await updateProfile(data)
      if (res.status === 200) {
        onNextCallback()
      } else {
        setRequestError(true)
      }
      setLoading(false)
    }
  })

  useEffect(() => {
    if (questions?.length > 0 && subStep < onboardingSteps[0].maxSubSteps - 1) {
      const questionId = questions[subStep]?.questionId
      if (answers?.[questionId] === undefined) {
        setShowNext(false)
      } else {
        setShowNext(true)
      }
    } else {
      setShowNext(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subStep, questions])

  const onNext = () => {
    if (subStep >= onboardingSteps[0].maxSubSteps - 1 && formik.dirty) {
      formik.submitForm()
    } else {
      onNextCallback()
    }
  }

  const GetOptions = (options, questionId) => {
    return (
      <ToggleOptions
        value={answers[questionId]}
        options={options.map(v => ({
          label: v.label,
          value: v.value
        }))}
        onChange={newValue => {
          const newAnswers = { ...answers }
          newAnswers[questionId] = parseInt(newValue, 10)
          setAnswers(newAnswers)
          formik.setFieldValue('questionnaireAnswers', newAnswers)
          setTimeout(() => {
            onNext()
          }, 750)
        }}
      />
    )
  }

  return (
    <>
      <OverlayLoading open={loading} />
      {questions[subStep] ? (
        <QuestionOptionsTemplate
          question={questions[subStep].questionText}
          options={GetOptions(questions[subStep].options, subStep)}
        />
      ) : (
        <StepOneProfilePhoto
          formik={formik}
          profileImage={profileImage}
          setProfileImage={setProfileImage}
          answers={Object.keys(answers)?.map(
            questionId =>
              questions[questionId]?.options?.find(
                option => option.value === answers[questionId]
              )?.label || ''
          )}
        />
      )}

      <Grid position='sticky'>
        <NavigateButtons
          onNext={onNext}
          onBack={onBackCallback}
          showNext={showNext}
          backProps={{
            disabled: subStep === 0,
            variant: subStep === 0 ? 'text' : 'contained'
          }}
        />
      </Grid>

      {requestError && <RequestRetryAlert />}
    </>
  )
}

export default StepOne
